import { Theme, alpha, keyframes } from '@mui/material';

export const stepEnter = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const staggerIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const staggerSx = {
  '& > *': {
    opacity: 0,
    animation: `${staggerIn} 360ms cubic-bezier(0.2, 0.8, 0.2, 1) both`,
  },
  '& > *:nth-of-type(1)': { animationDelay: '120ms' },
  '& > *:nth-of-type(2)': { animationDelay: '200ms' },
  '& > *:nth-of-type(3)': { animationDelay: '280ms' },
  '& > *:nth-of-type(4)': { animationDelay: '360ms' },
};

export const inputSx = (theme: Theme) => ({
  fontFamily: 'inherit',
  fontSize: 'body1.fontSize',
  padding: '14px 16px',
  background: '#fff',
  border: `1px solid ${theme.palette.darkerLightGrey.main}`,
  borderRadius: '12px',
  color: 'text.primary',
  width: '100%',
  boxSizing: 'border-box' as const,
  transition: theme.transitions.create(['border-color', 'box-shadow'], {
    duration: 160,
  }),
  '&:hover': { borderColor: theme.palette.outlineGrey.main },
  '&:focus': {
    outline: 'none',
    borderColor: theme.palette.darkGrey.main,
    boxShadow: `0 0 0 4px ${alpha(theme.palette.darkGrey.main, 0.08)}`,
  },
});
